import { Link } from "react-router-dom";
import { useI18n } from "../I18nContext";

/**
 * Shared "Coming soon" landing page for Services, Offerings, Solutions.
 * Pass slug to look up translations under toolbox.<slug>Title / <slug>Body
 * and the optional bullet list under toolbox.<slug>Bullets (array).
 */
export default function ComingSoon({ slug }) {
  const { t, lang } = useI18n();
  const bullets = (() => {
    const key = `toolbox.${slug}Bullets`;
    const raw = t(key);
    if (raw === key) return [];
    try { return JSON.parse(raw); } catch { return []; }
  })();

  return (
    <div className="tb-page" data-testid={`coming-soon-${slug}`}>
      <Link to="/app/toolbox" className="tb-muted" style={{ textDecoration: "none", fontSize: "0.85rem" }} data-testid="coming-soon-back">
        ← {t("comingSoon.backToToolbox")}
      </Link>
      <div className="tb-block" style={{ marginTop: 20, padding: "2.5rem", textAlign: "center" }}>
        <span className="tb-badge accent" data-testid="coming-soon-badge">{t("toolbox.comingSoon")}</span>
        <h1 className="tb-h1" style={{ marginTop: 16 }} data-testid="coming-soon-title">{t(`toolbox.${slug}Title`)}</h1>
        <p className="tb-muted" style={{ maxWidth: 580, margin: "0.6rem auto 1.6rem", fontSize: "1.05rem" }} data-testid="coming-soon-body">
          {t(`toolbox.${slug}Body`)}
        </p>
        {bullets.length > 0 && (
          <ul style={{ listStyle: "none", padding: 0, maxWidth: 480, margin: "0 auto", textAlign: "left" }} data-testid="coming-soon-bullets">
            {bullets.map((b, i) => (
              <li key={i} style={{ padding: "10px 14px", margin: "8px 0", borderRadius: 10, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
                <span style={{ marginRight: 10 }}>→</span>{b}
              </li>
            ))}
          </ul>
        )}
        <p className="tb-muted" style={{ marginTop: 24, fontSize: "0.85rem" }}>
          {lang === "fr" ? "Tu veux être prévenu·e au lancement ? Envoie-nous un feedback via le menu." : "Want to be notified at launch? Send us feedback from the menu."}
        </p>
      </div>
    </div>
  );
}
